import { withDisplayName } from '@hocs/with-display-name'
import RichText from '@resolvers/rich-text'
import { defaultRichTextFieldOptionsDeprecated } from '@resolvers/rich-text/default-rich-text-field-options-deprecated'
import { contentArticleTitleOptions } from '@rich-text/contentful-content-article-rich-text'
import { CtaLink } from '@ui/cta-link'
import {
  ENHANCED_COMPONENT_ROLE,
  ENHANCED_COMPONENT_TYPE,
} from '@ui/enhanced-components/types'
import clsx from 'clsx'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulContentArticleUnificationTransparentCard: Utils.EntryFC<
  Queries.ContentfulContentArticleUnificationTransparentCardFragment
> = ({
  content: {
    contentArticleTitle: title,
    content,
    contentLinkText,
    contentLinkUrl,
  },
  entryInspectorProps,
  fieldInspectorProps,
}) => {
  const hasFooterLink = contentLinkText && contentLinkUrl

  return (
    <div
      className={clsx(
        'flex h-full w-full flex-col justify-between rounded-[24px] border-[0.5px] border-solid px-6 py-[56px]',
        'group-[.is-grey]/section-template:bg-background-default',
        'group-[.is-grey]/section-template:border-[#E8EEE8]',
        'group-[.is-grey]/section-template:text-amplification-black-premium',
        'group-[.is-premium-black]/section-template:bg-[#FFFFFF20]',
        'group-[.is-premium-black]/section-template:text-[#FFFFFF]',
        'group-[.is-premium-black]/section-template:border-[#FFFFFF10]',
        'group-[.is-white]/section-template:bg-[#F2F5F2]',
        'group-[.is-white]/section-template:border-[#EDEDED]',
        'group-[.is-white]/section-template:text-amplification-black-premium',
        'group-[.is-iconic]/section-template:bg-[linear-gradient(309deg,_rgba(255,_255,_255,_0.05)_6%,rgba(171,_217,_255,_0.20)_171%)]',
        'group-[.is-iconic]/section-template:text-[#FFFFFF]',
        'group-[.is-iconic]/section-template:backdrop-blur-md',
        'group-[.is-iconic]/section-template:border-[#FFFFFF20]'
      )}
      {...entryInspectorProps()}
    >
      <div>
        <div className="mb-3 text-center">
          {title && (
            <RichText
              {...fieldInspectorProps({
                fieldId: 'title',
              })}
              content={title}
              options={contentArticleTitleOptions}
            />
          )}
        </div>
        <div className="grow self-stretch text-center">
          <RichText
            {...fieldInspectorProps({
              fieldId: 'content',
            })}
            content={content}
            options={defaultRichTextFieldOptionsDeprecated}
          />
        </div>
      </div>
      {hasFooterLink && (
        <div className="mt-10 flex justify-center">
          <CtaLink
            data-role={ENHANCED_COMPONENT_ROLE.SECONDARY}
            data-type={ENHANCED_COMPONENT_TYPE.CTA}
            href={contentLinkUrl}
            {...fieldInspectorProps({
              fieldId: 'contentLinkText',
            })}
            className={clsx(
              'group-[.is-premium-black]/section-template:text-[#FFFFFF]',
              'group-[.is-iconic]/section-template:text-[#FFFFFF]',
              'group-[.is-white]/section-template:text-amplification-black-premium',
              'group-[.is-grey]/section-template:text-amplification-black-premium'
            )}
          >
            {contentLinkText}
          </CtaLink>
        </div>
      )}
    </div>
  )
}

export const query = graphql`
  fragment ContentfulContentArticleUnificationTransparentCard on Contentful4TmD9EihHakmKMkEwKaUwQ {
    ...ContentfulEntry
    contentArticleTitle: title {
      ...ContentfulContentArticleTitle
    }
    content {
      ...ContentfulContentArticleContent
    }
    contentLinkText
    contentLinkUrl
  }
`

export default withDisplayName(
  ContentfulContentArticleUnificationTransparentCard,
  'ContentfulContentArticleUnificationTransparentCard'
)
